import { useMemo } from 'react'
import { useLocation } from 'react-use'
import { useQueryString } from '@global/hooks'

export const DATE_FILTER_OPTIONS = [
  { name: 'Last 30 days', id: 30 },
  { name: 'Last 60 days', id: 60 },
  { name: 'Last 3 months', id: 90 },
  { name: 'Last 6 months', id: 180 },
] as const

const DEFAULT_NUMBER_OF_DAYS_TO_FILTER =
  '180' as const satisfies `${(typeof DATE_FILTER_OPTIONS)[number]['id']}`

const DEFAULT_ROW_LEVEL_FILTER = 'submission' as const

export function useFilters() {
  const location = useLocation()
  const { setUrl } = useQueryString()

  const { numberOfDaysToFilter, filteredBy } = useMemo(() => {
    const queryParams = new URLSearchParams(location.search)

    return {
      numberOfDaysToFilter: queryParams.get('filteredDays') || '',
      filteredBy: queryParams.get('filteredBy') || '',
    }
  }, [location.search])

  if (!numberOfDaysToFilter && !filteredBy) {
    setUrl({ filteredDays: DEFAULT_NUMBER_OF_DAYS_TO_FILTER, filteredBy: DEFAULT_ROW_LEVEL_FILTER })
  }

  const isFilteredByRow = filteredBy === 'row' ? 1 : 0

  function setFilter(filter) {
    setUrl({ filteredDays: numberOfDaysToFilter, filteredBy, ...filter })
  }

  return {
    numberOfDaysToFilter: numberOfDaysToFilter || DEFAULT_NUMBER_OF_DAYS_TO_FILTER,
    filteredBy: filteredBy || DEFAULT_ROW_LEVEL_FILTER,
    isFilteredByRow,
    setFilter,
  }
}
